import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchCreateUserReplyTemplate,
  type TCreateUserReplyTemplateResponse,
  type TCreateUserReplyTemplateRequest,
} from '../../repositories/chats/v1/create-user-reply-template';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

export async function createUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TCreateUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TCreateUserReplyTemplateResponse> =
      await fetchCreateUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw new HttpBadStatusCodeError(response.message || '', statusCode);
    }

    return response;
  } catch (e) {
    logger.error(e, {
      description: 'Ошибка создания шаблона ответа',
    });

    throw e;
  }
}
